module.exports = __webpack_public_path__ + "c3cd4305fe0321f5ce21a486dc8999e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/step-3.png
// module id = 172
// module chunks = 0 1